import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import styles from '../mailInfo.module.scss';
import { EnmuRecurrenceRule, loopRules } from '@web-schedule/components/CreateBox/util';
import { useAppSelector } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
import { getReminderText } from '@web-schedule/util';
const conferenceDate = (conferenceState) => {
    const { moments: { startDate, startTime, endDate, endTime }, time: { allDay }, } = conferenceState;
    const endYYYY = moment(endDate).format(getIn18Text('YYYYNIAN@'));
    const endMMMdo = moment(endDate).format(getIn18Text('MMYUEDD'));
    const enddddd = moment(endDate).format('ddd');
    const endClock = moment(endTime).format('LT');
    const startYYYY = moment(startDate).format(getIn18Text('YYYYNIAN@'));
    const startMMMDo = moment(startDate).format(getIn18Text('MMYUEDD'));
    const startdddd = moment(startDate).format('ddd');
    const startClock = moment(startTime).format('LT');
    const crossYYYY = endYYYY !== moment(new Date()).format(getIn18Text('YYYYNIAN@'));
    const crossMMMDo = endMMMdo !== startMMMDo;
    let res = '';
    switch (true) {
        case !crossYYYY && !crossMMMDo && allDay:
            res = `${endMMMdo} (${enddddd})`;
            break;
        case !crossYYYY && crossMMMDo && allDay:
            res = `${startMMMDo} (${startdddd}) - ${endMMMdo} (${enddddd})`;
            break;
        case crossYYYY && !crossMMMDo && allDay:
            res = `${endYYYY}${endMMMdo} (${enddddd})`;
            break;
        case crossYYYY && crossMMMDo && allDay:
            res = `${startYYYY}${startMMMDo} (${startdddd}) - ${endYYYY}${endMMMdo} (${enddddd})`;
            break;
        case !crossYYYY && !crossMMMDo && !allDay:
            res = `${endMMMdo} (${enddddd}) ${startClock}-${endClock}`;
            break;
        case !crossYYYY && crossMMMDo && !allDay:
            res = `${startMMMDo} (${startdddd}) ${startClock} - ${endMMMdo} (${enddddd}) ${endClock}`;
            break;
        case crossYYYY && !crossMMMDo && !allDay:
            res = `${endYYYY}${endMMMdo} (${enddddd}) ${startClock}-${endClock}`;
            break;
        case crossYYYY && crossMMMDo && !allDay:
            res = `${startYYYY}${startMMMDo} (${startdddd}) ${startClock} - ${endYYYY}${endMMMdo} (${enddddd}) ${endClock}`;
            break;
        default:
            break;
    }
    return res;
};
const ConferenceDesc = () => {
    var _a;
    const conferenceState = useAppSelector(state => state.mailReducer.currentMail.conference);
    if (!conferenceState)
        return null;
    const { enmuRecurrenceRule: fixedEnmuRecurrenceRule, enmuReminders, reminders, time: { allDay }, location, } = conferenceState;
    const date = conferenceDate(conferenceState);
    const [enmuRecurrenceRule] = (fixedEnmuRecurrenceRule === null || fixedEnmuRecurrenceRule === void 0 ? void 0 : fixedEnmuRecurrenceRule.split('/')) || [];
    const recurrenceDesc = (_a = loopRules.find(i => i.value === enmuRecurrenceRule)) === null || _a === void 0 ? void 0 : _a.label;
    const recurrenceRule = EnmuRecurrenceRule.NONE === enmuRecurrenceRule ? '' : `, ${recurrenceDesc}`;
    const reminderDesc = reminders ? getReminderText(reminders, allDay) : '';
    const reminderRule = enmuRecurrenceRule === null ? '' : ` ${reminderDesc}`;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: classnames(styles.descItem) },
            React.createElement("img", { className: classnames(styles.conferenceDescIcon), src: require('@/images/icons/calendarDetail/clock.png') }),
            date,
            recurrenceRule),
        !!location && (React.createElement("span", { className: classnames(styles.descItem) },
            React.createElement("img", { className: classnames(styles.conferenceDescIcon), src: require('@/images/icons/calendarDetail/location.png') }),
            location)),
        !!reminderRule && (React.createElement("span", { className: classnames(styles.descItem) },
            React.createElement("img", { className: classnames(styles.conferenceDescIcon), src: require('@/images/icons/calendarDetail/bell.png') }),
            reminderRule))));
};
export default ConferenceDesc;
